// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"a8fe8658d49199ea14ef","293":"5a704012c97c0fc53ecd","518":"dc0e7f3cca71a587738b","779":"21a228168f1f82a8d538"}[chunkId] + ".js";
};